import { render, staticRenderFns } from "./infosh.vue?vue&type=template&id=37b3da17&scoped=true"
import script from "./infosh.vue?vue&type=script&lang=js"
export * from "./infosh.vue?vue&type=script&lang=js"
import style0 from "./infosh.vue?vue&type=style&index=0&id=37b3da17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3da17",
  null
  
)

export default component.exports